import { createPendingTiming } from "./timingCore";
import { APP_KPI_NAME } from "./utils";

export interface FieldNavigationContext {
  module: string;
  screen: string;
  action: string;
  fromField: string;
  toField: string;
  role?: string;
  entityType?: string;
  entityId?: string;
}

function buildProperties(
  context: FieldNavigationContext,
  durationMs: number,
  success: boolean,
  errorMessage?: string,
) {
  return {
    module: context.module,
    screen: context.screen,
    action: context.action,
    fromField: context.fromField,
    toField: context.toField,
    role: context.role ?? "",
    entityType: context.entityType ?? "",
    entityId: context.entityId ?? "",
    success,
    durationMs,
    ...(errorMessage ? { errorMessage } : {}),
  };
}

const fieldNavigationTiming = createPendingTiming<FieldNavigationContext>({
  metricName: APP_KPI_NAME.PCS_FIELD_NAVIGATION,
  completedEventName: "pcs_field_navigation_completed",
  failedEventName: "pcs_field_navigation_failed",
  buildProperties,
});

export function trackFieldNavigationCompleted(context: FieldNavigationContext, startedAt: number) {
  fieldNavigationTiming.trackCompleted(context, startedAt);
}

export function trackFieldNavigationFailed(
  context: FieldNavigationContext,
  startedAt: number,
  error: unknown,
) {
  fieldNavigationTiming.trackFailed(context, startedAt, error);
}

export function startFieldNavigationTiming(id: string, context: FieldNavigationContext) {
  fieldNavigationTiming.start(id, context);
}

export function completeFieldNavigationTiming(id: string): boolean {
  return fieldNavigationTiming.complete(id);
}

export function failFieldNavigationTiming(id: string, error: unknown): boolean {
  return fieldNavigationTiming.fail(id, error);
}

export function hasPendingFieldNavigation(id: string): boolean {
  return fieldNavigationTiming.has(id);
}

export function clearFieldNavigationTiming(id: string) {
  fieldNavigationTiming.clear(id);
}
